module["exports"] = [
  "ул.",
  "улица",
  "проспект",
  "пр.",
  "площадь",
  "пл."
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/ru/address/street_suffix.js
 ** module id = 981
 ** module chunks = 0
 **/